import { useSignal } from "@preact/signals";
import { useEffect } from "preact/hooks";
import { t } from "@/i18n";

const KEY = "mathrpg.cookies";

function acknowledged(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return true; // storage unavailable: nothing is stored, so nothing to announce
  }
}

/** One-time notice about local storage and the login cookie; no tracking exists to consent to. */
export function CookieNotice() {
  const shown = useSignal(!acknowledged());
  const accept = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch {
      /* ignore */
    }
    shown.value = false;
  };
  useEffect(() => {
    if (!shown.value) return;
    const onKey = (e: KeyboardEvent) => {
      if (
        e.key === "Enter" &&
        !(e.target instanceof HTMLInputElement) &&
        !(e.target instanceof HTMLButtonElement)
      ) {
        e.preventDefault();
        accept();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [shown.value]);
  if (!shown.value) return null;
  return (
    <div class="cookie-notice" role="dialog" aria-live="polite">
      <span>🍪 {t("cookie.text")}</span>
      <button class="primary" onClick={accept}>
        {t("cookie.ok")}
      </button>
    </div>
  );
}
